import { gql } from '@apollo/client'

const GET_CLIENT_PORTAL_SETTINGS = gql`
  query GetClientPortalSettings {
    client_portal_settings {
      language
      currency
      general_terms_and_conditions_url
      logo_url
      browser_title
      main_color
      show_partner_actual_balance
      show_co2_saving
      zip_code_input
      pick_up_floor_door_input
      handover_floor_door_input
      pick_up_city_input
      handover_city_input
      pick_up_first_name_input
      handover_first_name_input
      pick_up_last_name_input
      handover_last_name_input
      pick_up_phone_input
      handover_phone_input
      pick_up_email_input
      handover_email_input
      pick_up_company_input
      handover_company_input
      pick_up_note_input
      handover_note_input
      pick_up_description
      handover_description
      order_info_description
      summary_description
    }
  }
`

export { GET_CLIENT_PORTAL_SETTINGS }
